<template>
    <div class="product-regroupment" v-loading="loading">
        <span v-if="group.name">Regroupement : {{ group.name }}</span>
        <el-table  style="width: 100%" :data="group.products" stripe>
            <el-table-column label="Visuel">
                <template slot-scope="scope">
                    <img v-if="scope.row.images.length" :src="'/ic/small/'+scope.row.images[0].path" alt="">
                    <div v-else class="placeholder-img">Pas d'image</div>
                </template>
            </el-table-column>
            <el-table-column label="Name">
                <template slot-scope="scope">
                    {{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="ean13" label="Code barre">
                <template slot-scope="scope">
                    {{ scope.row.ean13 }}
                </template>
            </el-table-column>
            <el-table-column prop="external_ref" label="Référence fournisseur">
                <template slot-scope="scope">
                    {{ scope.row.external_ref }}
                </template>
            </el-table-column>
            <el-table-column label="Actions" sortable="custom" width="90">
                <template slot-scope="scope">
                    <a  href="#" class="text-danger" @click.prevent="remove(scope.row)"><i class="fe fe-trash-2"></i></a>
                </template>
            </el-table-column>
        </el-table>


    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            group: {
                products: []
            }
        };
    },
    props: {
        product: {
            required: true
        }
    },
    computed: {
        productId() {
            return this.product.id;
        },
    },
    watch: {
        productId(newV, oldV) {
            if (!newV) return;
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.loading = true;
            this.fetch().then(() => {
                this.loading = false;
            });
        },
        fetch() {
            return axios
                .get('/products/' + this.productId + '/groups/regroupment_product')
                .then(r => {
                    this.group  = r.data
                });
        },

        remove(product) {
            this.$confirm('Voulez-vous supprimer le produit du regroupement', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios
                        .delete(
                            '/groups/products/' +
                                product.id
                        )
                        .then(r => {
                            this.removeToList(product);
                        })
                        .catch((e) => {
                            console.error(e)
                        })
                        .then(() => {
                        });
                })
                .catch(() => {});
        },
        removeToList(product) {
            this.group.products.splice( this.group.products.findIndex(v => v.id == product.id), 1 );
        }
    }
};
</script>
<style lang="scss">
.product-variations {
    .silent-link {
        &:hover {
            text-decoration: none;
        }
    }
    .placeholder-img {
        text-align: center;
        width: 120px;
        height: 90px;
        background: #e7e7e7;
        vertical-align: middle;
        display: table-cell;
        color: #007bfffc;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>
